import { render, staticRenderFns } from "./LoggedInUser.vue?vue&type=template&id=464556d2&scoped=true&"
import script from "./LoggedInUser.vue?vue&type=script&lang=js&"
export * from "./LoggedInUser.vue?vue&type=script&lang=js&"
import style0 from "./LoggedInUser.vue?vue&type=style&index=0&id=464556d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464556d2",
  null
  
)

export default component.exports